if (!customElements.get('nv-canonical-gallery')) {
  customElements.define('nv-canonical-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.frames = Array.from(this.querySelectorAll('[data-nv-frame]'));
      if (!this.frames.length) return;
      this.index = 0;
      this.thumbs = this.querySelector('.nv-cg__thumbs');
      this.buttons = this.frames.map((frame, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Ver imagen ${index + 1}`);
        const image = frame.querySelector('img');
        if (image) {
          const thumb = document.createElement('img');
          thumb.src = image.currentSrc || image.src;
          thumb.alt = '';
          thumb.loading = 'lazy';
          button.append(thumb);
        } else button.textContent = String(index + 1);
        button.addEventListener('click', () => this.show(index));
        this.thumbs.append(button);
        return button;
      });
      this.querySelector('[data-nv-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-nv-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dialog = this.querySelector('dialog');
      this.zoomViewport = this.dialog.querySelector('.nv-cg__zoom-viewport');
      this.zoomToggle = this.dialog.querySelector('[data-nv-toggle-detail]');
      this.dialog.querySelector('[data-nv-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.querySelector('[data-nv-dialog-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.dialog.querySelector('[data-nv-dialog-next]').addEventListener('click', () => this.show(this.index + 1));
      this.zoomToggle.addEventListener('click', () => {
        const detail = this.dialog.classList.toggle('nv-cg__zoom--detail');
        this.zoomToggle.setAttribute('aria-pressed', String(detail));
        this.zoomToggle.textContent = detail ? 'Ver imagen completa' : 'Ver detalle';
        this.dialog.querySelector('[data-nv-hint]').textContent = detail ? 'Arrastra la imagen para examinarla.' : 'Desliza para cambiar de imagen.';
        this.zoomViewport.scrollTo(0, 0);
      });
      this.querySelector('[data-nv-zoom]').addEventListener('click', () => {
        this.dialog.classList.remove('nv-cg__zoom--detail');
        this.zoomToggle.setAttribute('aria-pressed', 'false');
        this.zoomToggle.textContent = 'Ver detalle';
        this.dialog.querySelector('[data-nv-hint]').textContent = 'Desliza para cambiar de imagen.';
        this.updateDialogImage();
        this.dialog.showModal();
      });
      this.dialog.addEventListener('keydown', event => {
        if (this.dialog.classList.contains('nv-cg__zoom--detail')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      this.zoomViewport.addEventListener('touchstart', event => {
        this.modalTouch = event.touches.length === 1 && !this.dialog.classList.contains('nv-cg__zoom--detail')
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      this.zoomViewport.addEventListener('touchend', event => {
        const start = this.modalTouch;
        this.modalTouch = null;
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.show(this.index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      this.zoomViewport.addEventListener('touchcancel', () => { this.modalTouch = null; }, { passive: true });
      this.querySelector('.nv-cg__controls').hidden = false;
      this.thumbs.hidden = false;
      this.show(0, false);
      const surface = this.querySelector('.nv-cg__frames');
      surface.addEventListener('touchstart', event => {
        this.touch = event.touches.length === 1 && matchMedia('(max-width: 749px)').matches
          ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
      }, { passive: true });
      surface.addEventListener('touchmove', event => {
        if (!this.touch || event.touches.length !== 1) { this.touch = null; return; }
        const dx = event.touches[0].clientX - this.touch.x;
        const dy = event.touches[0].clientY - this.touch.y;
        if (Math.abs(dy) > 12 && Math.abs(dy) >= Math.abs(dx)) this.touch = null;
      }, { passive: true });
      surface.addEventListener('touchend', event => {
        const start = this.touch;
        this.touch = null;
        if (!start || !event.changedTouches.length) return;
        const dx = event.changedTouches[0].clientX - start.x;
        const dy = event.changedTouches[0].clientY - start.y;
        if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy) * 1.3) this.show(this.index + (dx < 0 ? 1 : -1));
      }, { passive: true });
      surface.addEventListener('touchcancel', () => { this.touch = null; }, { passive: true });
      this.resizeObserver = new ResizeObserver(() => {
        this.revealThumb(false);
        // Image stays fitted to the viewport until the customer chooses detail zoom.
      });
      this.resizeObserver.observe(this);
    }
    updateDialogImage() {
      const source = this.frames[this.index]?.querySelector('img');
      const image = this.zoomViewport?.querySelector('img');
      if (!source || !image) return;
      image.src = source.currentSrc || source.src;
      image.alt = source.alt || '';
      this.dialog.querySelector('[data-nv-dialog-count]').textContent = `${this.index + 1} / ${this.frames.length}`;
      this.zoomViewport.scrollTo(0, 0);
    }
    revealThumb(smooth = true) {
      const button = this.buttons?.[this.index];
      if (!button || !this.thumbs.clientWidth) return;
      const rail = this.thumbs.getBoundingClientRect();
      const thumb = button.getBoundingClientRect();
      let target = this.thumbs.scrollLeft;
      if (this.index === 0) target = 0;
      else if (this.index === this.buttons.length - 1) target = this.thumbs.scrollWidth - this.thumbs.clientWidth;
      else if (thumb.left < rail.left + 2) target += thumb.left - rail.left - 2;
      else if (thumb.right > rail.right - 2) target += thumb.right - rail.right + 2;
      if (Math.abs(target - this.thumbs.scrollLeft) > 1) this.thumbs.scrollTo({ left: target, behavior: smooth && !matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto' });
    }
    show(index, smooth = true) {
      if (!this.frames?.length) return;
      this.index = (index + this.frames.length) % this.frames.length;
      this.frames.forEach((frame, i) => {
        frame.hidden = i !== this.index;
        if (frame.hidden) frame.querySelectorAll('video').forEach(video => video.pause());
        this.buttons[i].setAttribute('aria-current', String(i === this.index));
      });
      this.querySelector('[data-nv-status]').textContent = `${this.index + 1} / ${this.frames.length}`;
      this.querySelector('[data-nv-zoom]').hidden = !this.frames[this.index].querySelector('img');
      this.revealThumb(smooth);
      if (this.dialog?.open) this.updateDialogImage();
    }
    setActiveMedia(mediaId) {
      const index = this.frames.findIndex(frame => frame.dataset.mediaId === mediaId);
      if (index >= 0) this.show(index);
    }
  });
}
